// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__38GzB","footer":"ModalCreateQualiphyProcedure_footer__3it7n","additionData":"ModalCreateQualiphyProcedure_additionData__1Ep-G"};